// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eE{margin-bottom:10px}.eE p{margin-bottom:0}.eE .fE{font-size:.8em;padding-left:10px}", "",{"version":3,"sources":["webpack://./src/components/modalInfo/ModalInfo.module.scss"],"names":[],"mappings":"AAAA,IACC,kBAAA,CAEA,MACC,eAAA,CAGD,QACC,cAAA,CACA,iBAAA","sourcesContent":[".taskUploadLog {\r\n\tmargin-bottom: 10px;\r\n\r\n\tp {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\r\n\t.taskUploadLogData {\r\n\t\tfont-size: 0.8em;\r\n\t\tpadding-left: 10px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"taskUploadLog": "eE",
	"taskUploadLogData": "fE"
};
export default ___CSS_LOADER_EXPORT___;
